import moment from 'moment-timezone';

const ConvertUkTimeZone = () => {
    // const ukTz = "Europe/London"; 
    // const ukTz='Asia/Dubai'
    const ukTz = "Asia/Kolkata";

    return moment.tz(new Date(), ukTz);
}

export default ConvertUkTimeZone;